import styled from 'styled-components';

/**
 * Enhanced wrapper for multi-select dropdown with increased height and improved styling
 * Use this wrapper when you need a larger, more prominent dropdown
 */
export const MultiSelectDropdownEnhancedWrapper = styled.div`
  width: 100%;

  /* Dropdown control */
  .dropdown-control {
    min-height: 2.5rem !important;
    padding: 0.5rem 0.875rem !important;
    border-radius: 0.5rem !important;
    border: 1px solid rgba(104, 70, 209, 0.2) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    background: #ffffff !important;
    box-shadow: 0 1px 3px rgba(104, 70, 209, 0.05) !important;

    &:hover {
      border-color: rgba(104, 70, 209, 0.4) !important;
      box-shadow: 0 2px 6px rgba(104, 70, 209, 0.1) !important;
    }

    &.open {
      border-color: #6846d1 !important;
      box-shadow: 0 0 0 3px rgba(104, 70, 209, 0.15) !important;
    }
  }

  /* Dropdown title text */
  .dropdown-title {
    font-size: 0.875rem !important;
    color: #1f2937 !important;
    line-height: 1.5 !important;
    font-weight: 500 !important;
  }

  /* Placeholder styling */
  .placeholder {
    font-size: 0.875rem !important;
    color: #9ca3af !important;
    font-weight: 400 !important;
  }

  /* Dropdown arrow */
  .dropdown-arrow {
    font-size: 0.75rem !important;
    color: #6846d1 !important;
    transition: color 0.3s ease !important;
  }

  /* Dropdown menu */
  .dropdown-menu {
    min-width: 100% !important;
    max-height: 22rem !important;
    border-radius: 0.5rem !important;
    box-shadow: 0 10px 25px rgba(104, 70, 209, 0.15) !important;
    border: 1px solid rgba(104, 70, 209, 0.15) !important;
    margin-top: 0.5rem !important;
  }

  /* Search input */
  .search-input {
    font-size: 0.875rem !important;
    padding: 0.625rem 2.5rem 0.625rem 0.875rem !important;
    border: none !important;
    border-bottom: 1px solid rgba(104, 70, 209, 0.1) !important;
    border-radius: 0 !important;
    transition: all 0.3s ease !important;

    &::placeholder {
      color: #9ca3af !important;
      font-size: 0.875rem !important;
    }

    &:focus {
      border-bottom-color: #6846d1 !important;
      background: #faf9fe !important;
      outline: none !important;
    }
  }

  /* Search container */
  .search-container {
    padding: 0.5rem !important;
    border-bottom: 1px solid rgba(104, 70, 209, 0.08) !important;
  }

  /* Select all option */
  .select-all-option {
    padding: 0.625rem 0.875rem !important;
    font-size: 0.875rem !important;
    font-weight: 600 !important;
    color: #6846d1 !important;
    border-bottom: 1px solid rgba(104, 70, 209, 0.1) !important;
    background: linear-gradient(to right, #faf9fe, #ffffff) !important;

    &:hover {
      background: linear-gradient(to right, #f3f0ff, #faf9fe) !important;
    }

    input[type='checkbox'] {
      accent-color: #6846d1 !important;
    }
  }

  /* Options container */
  .options-container {
    max-height: 16rem !important;

    /* Custom scrollbar */
    &::-webkit-scrollbar {
      width: 8px !important;
    }

    &::-webkit-scrollbar-track {
      background: #f3f4f6 !important;
      border-radius: 4px !important;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(to bottom, #6846d1, #8b5cf6) !important;
      border-radius: 4px !important;

      &:hover {
        background: linear-gradient(to bottom, #5a3bb8, #7c4ddb) !important;
      }
    }

    .option {
      padding: 0.625rem 0.875rem !important;
      font-size: 0.875rem !important;
      transition: all 0.2s ease !important;

      &:hover {
        background: linear-gradient(to right, #faf9fe, #ffffff) !important;
      }

      label {
        font-size: 0.875rem !important;
        color: #374151 !important;
        font-weight: 400 !important;
        cursor: pointer !important;
      }

      input[type='checkbox'] {
        width: 1.125rem !important;
        height: 1.125rem !important;
        margin-right: 0.625rem !important;
        cursor: pointer !important;
        accent-color: #6846d1 !important;
      }
    }
  }

  /* No options message */
  .no-options {
    padding: 1.5rem !important;
    font-size: 0.875rem !important;
    color: #9ca3af !important;
    text-align: center !important;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .dropdown-menu {
      max-height: 18rem !important;
    }

    .options-container {
      max-height: 13rem !important;
    }
  }

  @media (max-width: 576px) {
    .dropdown-control {
      min-height: 2.25rem !important;
      padding: 0.375rem 0.75rem !important;
    }

    .dropdown-title,
    .placeholder {
      font-size: 0.8125rem !important;
    }

    .search-input,
    .option label,
    .select-all-option {
      font-size: 0.8125rem !important;
    }
  }
`;
